var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentFall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6656 10.75C13.9896 10.75 13.4434 11.3086 13.4434 12C13.4434 12.6914 13.9896 13.25 14.6656 13.25H20.7767C21.4528 13.25 21.999 12.6914 21.999 12V5.75C21.999 5.05859 21.4528 4.5 20.7767 4.5C20.1007 4.5 19.5545 5.05859 19.5545 5.75V8.98047L13.0844 2.36719C12.6069 1.87891 11.8316 1.87891 11.3542 2.36719L7.33229 6.48047L2.08437 1.11719C1.60694 0.628906 0.831597 0.628906 0.354167 1.11719C-0.123264 1.60547 -0.123264 2.39844 0.354167 2.88672L6.46528 9.13672C6.94271 9.625 7.71806 9.625 8.19549 9.13672L12.2212 5.01953L17.8243 10.75H14.6656Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentFall);
export default __webpack_public_path__ + "static/media/percent-fall.ed96a0a5431922f70eec37005bec7204.svg";
export { ForwardRef as ReactComponent };